import React from 'react';
import { wrap, content, buttonArea } from './style';

interface Props {
  alertTitle?: string;
  onClose: () => void;
}

function Alert({
  alertTitle,
  children,
  onClose,
}: React.PropsWithChildren<Props>) {
  return (
    <div css={wrap} role="alertdialog" aria-modal="true">
      <div css={content}>{children}</div>
      <div css={buttonArea}>
        <button type="button" onClick={onClose} autoFocus>
          {alertTitle || '확인'}
        </button>
      </div>
    </div>
  );
}

export default Alert;
